export const TitleCode = "SF2"
export const StatusCode = "SF7"
export const ConceptCode = "SF19"
export const DescriptionComponentCode = "SF23"
export const CreatorComponentCode = "SF24"
export const CreatedOnComponentCode = "SF25"
export const LastUpdatedByComponentCode = "SF26"
export const LastUpdateComponentCode = "SF27"
export const CreatedOnBehalfOfComponentCode = "SF124"
export const LastUpdatedOnBehalfOfComponentCode = "SF125"
export const DueDateCode = "SF5"
